import React from 'react'

const UserData = ( {stats} ) => {
  return (
    <>
        {
            stats.map((item) => {
                const {rank, name, email} = item;

                return(
                    <tr key={item.team.id}> 
                        <td className='text-center'>{item.rank}</td>
                        <td className='text-right'> 
                            <img className="standinds-logo img-fluid" src={item.team.logo} 
                            width={45}
                            alt="Premier League Clubs"/> {item.team.name}
                        </td>
                        <td className='text-center'>{item.points}</td>
                        <td className='text-center'>{item.all.win}</td>
                        <td className='text-center'>{item.all.draw}</td>
                        <td className='text-center'>{item.all.lose}</td>
                        <td className='text-center'>{item.all.played}</td>
                    </tr>
                )
            })
            
        }
    </>
  )
}

export default UserData